import misRutas from 'vue-routes-generator'
import GestionHorariaComponent from './app'
import Listado from './listado/listado'
import Usuario from './usuario/usuario'
import Editor from './editor/editor'
import Estadisticas from './estadisticas/estadisticas'
import Equipos from './equipos/equipos'

export default {
	install: Vue => {
		misRutas.route('/main').child('horas-extra', {
			name: 'Gestión horaria',
			component: GestionHorariaComponent
		})

		misRutas.route('/main').child('horas-extra').child('listado', {
			name: 'Listados',
			component: Listado
		})

		misRutas.route('/main').child('horas-extra').child('editor/:id', {
			name: 'Registrar',
			component: Editor
		})

		misRutas.route('/main').child('horas-extra').child('usuario/:id', {
			name: 'Mis horas',
			component: Usuario
		})

		misRutas.route('/main').child('horas-extra').child('equipos', {
			name: 'Gestión de equipos',
			component: Equipos
		})

		misRutas.route('/main').child('horas-extra').child('estadisticas', {
			name: 'Estadísticas',
			component: Estadisticas
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-horaria/vue/index.js